import { render, staticRenderFns } from "./StatsCards.vue?vue&type=template&id=3a8acaa2&scoped=true"
import script from "./StatsCards.vue?vue&type=script&lang=js"
export * from "./StatsCards.vue?vue&type=script&lang=js"
import style0 from "./StatsCards.vue?vue&type=style&index=0&id=3a8acaa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8acaa2",
  null
  
)

export default component.exports